import { Link } from "react-router-dom";
import {
  ShieldCheck,
  CalendarCheck,
  Sparkle,
  Gift,
  CreditCard,
  Headset,
} from "@phosphor-icons/react";
import logoIcon from "../../assets/logo-icon.png";
import "./AuthLayout.css";

const VALUE_PROPS = {
  login: [
    { Icon: ShieldCheck, text: "מאגר מידע רפואי מאובטח" },
    { Icon: CalendarCheck, text: "כל הקליניקה שלכם במקום אחד" },
    { Icon: Sparkle, text: "סיכומי טיפול חכמים עם AI" },
  ],
  signup: [
    { Icon: Gift, text: "30 ימי ניסיון חינם" },
    { Icon: CreditCard, text: "ללא צורך בכרטיס אשראי" },
    { Icon: Headset, text: "הדרכה אישית חינם" },
  ],
};

const TAGLINES = {
  login: "מערכת ניהול הקליניקה של המטפלים בישראל",
  signup: "מצטרפים למאות מטפלים שכבר מנהלים קליניקה חכמה",
};

/**
 * AuthLayout
 * Split-screen shell for the public auth pages.
 * RTL page: form panel renders on the right (reading start),
 * brand panel on the left. On mobile the brand panel collapses
 * into a compact gradient header above the form.
 */
function AuthLayout({ variant = "login", footer, children }) {
  // Mouse-follow glow on the form card (same pattern as PatientsCards)
  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - rect.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - rect.top}px`);
  };

  return (
    <div className={`auth-layout auth-layout-${variant}`}>
      {/* Form panel */}
      <main className="auth-form-panel">
        <div className="auth-form-panel-inner">
          <div className="auth-panel-logo">
            <Link to="/" className="auth-panel-logo-link">
              <img src={logoIcon} alt="CliniKit" className="auth-panel-logo-icon" />
              <span className="auth-panel-logo-text">CliniKit</span>
            </Link>
          </div>

          <div className="auth-card" onMouseMove={handleMouseMove}>
            {children}
          </div>

          {footer && <div className="auth-panel-footer">{footer}</div>}
        </div>
      </main>

      {/* Brand panel */}
      <aside className="auth-brand-panel">
        <div className="auth-brand-inner">
          <Link to="/" className="auth-brand-logo">
            <img src={logoIcon} alt="" className="auth-brand-logo-icon" />
            <span className="auth-brand-logo-text">CliniKit</span>
          </Link>
          <p className="auth-brand-tagline">{TAGLINES[variant]}</p>

          {/* Decorative CSS-drawn mini dashboard */}
          <div className="auth-brand-illustration" aria-hidden="true">
            <div className="illus-card illus-card-back">
              <div className="illus-calendar">
                {Array.from({ length: 12 }, (_, i) => (
                  <span key={i} className="illus-calendar-cell" />
                ))}
              </div>
            </div>
            <div className="illus-card illus-card-front">
              <div className="illus-avatar" />
              <div className="illus-lines">
                <span className="illus-line illus-line-lg" />
                <span className="illus-line illus-line-md" />
                <span className="illus-line illus-line-sm" />
              </div>
              <div className="illus-check">✓</div>
            </div>
          </div>

          <ul className="auth-brand-props">
            {VALUE_PROPS[variant].map(({ Icon, text }) => (
              <li key={text} className="auth-brand-prop">
                <span className="auth-brand-prop-icon">
                  <Icon size={18} weight="fill" />
                </span>
                <span className="auth-brand-prop-text">{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </aside>
    </div>
  );
}

export default AuthLayout;
